import React, { useEffect, useState } from "react";
import "../../assets/css/ProductDetails.css";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import ProductImagesSlider from "../../Components/Slider/ProductImagesSlider";
import AllReviews from "../../Components/Reviews/AllReviews";
import ReviewBox from "../../Components/Reviews/ReviewBox";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import { no_image_product_details } from "../../constant";
import ActionButton from "../../Components/ActionBtn/ActionButton";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import {
  GetFrequentProducts,
  GetProductDetailsApi,
  GetProductRatingApi,
  PostAddWishList,
  PostProductReviewApi,
} from "../../network/Network";
import Skeleton from "react-loading-skeleton";
import { toast } from "react-toastify";
import { AddToCart } from "../../redux/actions/CartActions";
import { useDispatch, useSelector } from "react-redux";
import swal from "sweetalert";
import ReactPlayer from "react-player";

function ProductDetails() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ImageUrlRedux = useSelector((state) => state.AuthReducer.urlData);
  const cartDataRedux = useSelector((state) => state.CartReducer.cartData);
  const Token = useSelector((state) => state.AuthReducer.token);
  const CampaignReduxData = useSelector(
    (state) => state.AuthReducer.donationCampaign
  );
  let currentUrl = window.location.href.split("/");
  const [productDetails, setProductDetails] = useState(null);
  const [spinLoad, setSpinLoad] = useState(false);
  const [wishLoading, setWishLoading] = useState(false);

  const location = useLocation();
  const ParamData = location?.state?.data;
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [active, setActive] = useState(false);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [reviewLoading, setReviewLoading] = useState(false);
  const [select, setSelect] = useState([0, 1, 2, 3, 4]);
  const [frequentProducts, setFrequentProducts] = useState();

  const [reviewSpin, setReviewSpin] = useState(false);
  const [reviewData, setReviewData] = useState([]);
  const [submitReview, setSubmitReview] = useState(false);

  const [quantity, setQuantity] = useState(1);
  const [selectedSize, setSelectedSize] = useState("");
  const [selectedAddOn, setSelectedAddOn] = useState();
  const [selectCampPrice, setSelectCampPrice] = useState("");
  const [selectCamp_id, setSelectCamp_id] = useState("");
  const [freqSpin, setFreqSpin] = useState(false);
  const [waiting, setWaiting] = useState(false);

  const [zipCode, setZipCode] = useState();
  const [growingData, setGrowingData] = useState();
  const [growLoading, setGrowLoading] = useState(false);
  const [addFreq, setAddFreq] = useState([]);
  const [amount, setAmount] = useState("");

  const [freqSize, setFreqSize] = useState();
  const [freqSelectPrice, setFreqSelectPrice] = useState();
  const [freqSelect_Id, setFreqSelect_Id] = useState();

  const [freqSizeItem, setFreqSizeItem] = useState();
  const [selectedAddonData, setSelectedAddonData] = useState();
  const [selectedAddOnShow, setSelectedAddOnShow] = useState(false);
  const [addonQuantity, setAddonQuantity] = useState(1);
  const [selectedAddonSizeData, setSelectedAddonSizeData] = useState();
  const [selectedAddonArray, SetselectedAddonArray] = useState([]);

  const handleRating = (rate) => {
    setRating(rate);
  };

  // product Details
  useEffect(() => {
    setSpinLoad(true);
    GetProductDetailsApi(currentUrl[4])
      .then((res) => {
        setProductDetails(res?.data);
        setSpinLoad(false);
      })
      .catch((err) => {
        setSpinLoad(false);
      });
  }, [currentUrl[4]]);

  const AddWishListHandler = (e) => {
    e.preventDefault();
    setWishLoading(true);
    let data = {
      product_id: currentUrl[4],
    };
    PostAddWishList(data, Token)
      .then((res) => {
        setWishLoading(false);
        setActive(!active);
        toast.success("Product Added to your Wishlist");
      })
      .catch((err) => {
        setWishLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  const Increment = (id) => {
    setQuantity(quantity + 1);
  };
  const Decrement = (id) => {
    setQuantity(quantity - 1);
  };

  const IncrementAddon = (id) => {
    setAddonQuantity(addonQuantity + 1);
  };
  const DecrementAddon = (id) => {
    setAddonQuantity(addonQuantity - 1);
  };

  const SelectPacks = (e, item) => {
    if (!selectedSize) {
      toast.error("Please Select Size First");
      return;
    }
    let newVarient = productDetails?.variation.filter(
      (val) => val?.size == selectedSize
    );
    if (parseInt(item?.quantity) <= newVarient[0]?.qty) {
      if (amount == item?.price) {
        setAmount("");
        setQuantity(1);
      } else {
        setAmount(e.target.value);
        setQuantity(parseInt(item?.quantity, 10));
      }
    } else {
      toast.error("Selected pack is out of stock");
      return;
    }
  };

  const AddToCartHandler = (item) => {
    if (!selectedSize) {
      toast.error("Please Select Size");
      return;
    }
    if (productDetails?.variation) {
      let newVarient = productDetails?.variation.filter(
        (val) => val.size == selectedSize
      );
      if (newVarient[0]?.qty > 0) {
        let checkItemAlreadyExist = cartDataRedux.filter(
          (val) => val?.id === item?.id
        );
        let FindSelectedAddon;
        if (selectedAddOn) {
          FindSelectedAddon = item?.addons?.filter(
            (val) => val?.addon_id === parseInt(selectedAddOn)
          );
        }
        if (checkItemAlreadyExist.length > 0) {
          swal({
            title: "Item Already Exist in Cart!!!",
          });
          navigate("/cart");
        } else {
          let productSizeId = productDetails?.variation.filter(
            (val) => val?.size == selectedSize
          );
          let data = {
            id: item?.id,
            price:
              selectedSize && amount
                ? amount
                : selectedSize
                ? VariationPrice()
                : item?.unit_price,
            quantity: quantity,
            type: amount ? "bulk" : "",
            size: selectedSize,
            campaign_price: selectCampPrice ? selectCampPrice : "",
            campaign_id: selectCamp_id ? selectCamp_id : "",
            productitem: item,
            deliveryDate: "",
            addon_item: selectedAddonArray ? selectedAddonArray : "",
            // addon_id: selectedAddOn ? selectedAddOn : "",
            product_variant_id: productSizeId[0]?.id,
            // addon_item: selectedAddonArray ? selectedAddonArray : "",
            // product_variant_id: productSizeId[0]?.id,
          };
          dispatch(AddToCart(data));
          toast("Product successfully added");
        }
      } else {
        toast("Selected variation is out of stock");
        return;
      }
    }
  };

  const SubmitRating = (e) => {
    e.preventDefault();
    setReviewLoading(true);
    if (!rating) {
      toast.error("Please Enter Rating");
      setReviewLoading(false);
      return;
    }
    if (!comment) {
      toast.error("Please Comments");
      setReviewLoading(false);
      return;
    }
    let data = {
      product_id: productDetails?.id,
      comment: comment,
      rating: rating / 20,
    };
    PostProductReviewApi(data, Token)
      .then((res) => {
        setReviewLoading(false);
        toast.success("Successfully send");
        setSubmitReview(!submitReview);
        setRating("");
        setComment("");
      })
      .catch((err) => {
        setReviewLoading(false);
        setSubmitReview(!submitReview);
        if (err?.response?.data?.message === "Unauthenticated.") {
          toast.error("Please Login");
        }
        setRating("");
        setComment("");
      });
  };

  // product Reviews
  useEffect(() => {
    setReviewSpin(true);
    GetProductRatingApi(currentUrl[4])
      .then((res) => {
        setReviewData(res?.data?.data);
        setReviewSpin(false);
      })
      .catch((err) => {
        setReviewSpin(false);
      });
  }, [submitReview]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const FrequentAddToCartHandler = (e) => {
    let i;
    setWaiting(true);
    for (i = 0; i < addFreq?.length; i++) {
      let checkItemAlreadyExist = cartDataRedux.filter(
        (val) => val?.id === addFreq[i]?.item?.id
      );
      if (checkItemAlreadyExist?.length > 0) {
        alert("Item Already Exist in Cart!!!");
      } else {
        let data = {
          id: addFreq[i]?.item?.id,
          price: addFreq[i]?.selectedPrice,
          quantity: 1,
          size: addFreq[i]?.item?.variation ? addFreq[i]?.selectSize : " ",
          campaign_price: "",
          campaign_id: "",
          productitem: addFreq[i]?.item,
          deliveryDate: " ",
          addon_item: "",
          product_variant_id: addFreq[i]?.selectedVariant_Id,
        };
        dispatch(AddToCart(data));
      }
    }
    toast("Product successfully added");
    setWaiting(false);
    navigate("/cart");
  };

  // Frequent Products
  useEffect(() => {
    setFreqSpin(true);
    GetFrequentProducts(currentUrl[4])
      .then((res) => {
        setFrequentProducts(res?.data);
        setFreqSpin(false);
      })
      .catch((err) => {
        setFreqSpin(false);
      });
  }, [productDetails]);

  const AddFrequentHandler = (e, item) => {
    e.preventDefault();
    let data = addFreq?.filter((val) => val?.item?.id == item?.id);
    if (!freqSize && addFreq?.length < 1) {
      toast?.error("Please select Size first");
      return;
    }
    if (data[0]?.item?.id == item?.id) {
      setAddFreq((preVal) => {
        return [...preVal.filter((val) => val?.item?.id !== item?.id)];
      });
    } else {
      if (!freqSize) {
        toast?.error("Please select Size first");
        return;
      }
      if (FreqfilterVariationQty() > 0) {
        setAddFreq((preVal) => {
          return [
            ...preVal,
            {
              item,
              selectSize: freqSize,
              selectedPrice: freqSelectPrice,
              selectedVariant_Id: freqSelect_Id,
            },
          ];
        });
      } else {
        toast?.error("Selected Variant is out of stock");
        return;
      }
    }
    setFreqSize("");
    setFreqSelectPrice("");
    setFreqSelect_Id("");
  };

  const FrequentVariations = (e, item) => {
    setFreqSize(e);
    let variantPrice = item?.variation.filter((val) => val?.size == e);
    if (variantPrice?.length > 0) {
      setFreqSelectPrice(variantPrice[0]?.price);
      setFreqSelect_Id(variantPrice[0]?.id);
    }
    setFreqSizeItem(item);
    FreqfilterVariationQty();
    FrequentVariationPrice(e, item);
  };

  const FrequentVariationPrice = (e, item) => {
    let varient = freqSize;
    if (item?.variation) {
      let data = item?.variation?.filter((val) => val?.size === varient);
      if (data?.length > 0) {
        return data[0]?.price;
      }
    }
  };

  const FreqfilterVariationQty = () => {
    let varient = freqSize;
    if (freqSizeItem?.variation) {
      let newVarient = freqSizeItem?.variation.filter(
        (val) => val?.size == varient
      );
      if (newVarient.length > 0) {
        return newVarient[0].qty;
      }
      return;
    }
    return;
  };

  const filterVariationQty = () => {
    let varient = selectedSize;
    if (productDetails?.variation) {
      let newVarient = productDetails?.variation.filter(
        (val) => val?.size == varient
      );
      if (newVarient.length > 0) {
        return newVarient[0].qty;
      }
    }
  };

  const VariationPrice = () => {
    let varient = selectedSize;
    if (productDetails?.variation) {
      let data = productDetails?.variation?.filter(
        (val) => val?.size === varient
      );
      if (data?.length > 0) {
        return data[0]?.price;
      }
      return;
    }
    return;
  };

  const SelectedAddonDataHandler = (e) => {
    e.preventDefault();
    const Addon = productDetails?.variation?.filter(
      (val) => val?.size == e.target.value
    );
    setSelectedAddonData(Addon[0]?.addon);
  };

  const filterAddonVariationQty = () => {
    let varient = selectedAddOn;
    if (selectedAddonSizeData?.variation?.length > 0) {
      let newVarient = selectedAddonSizeData?.variation.filter(
        (val) => val?.product_id == varient
      );
      if (newVarient.length > 0) {
        return newVarient[0].qty || 1;
      }
      return 1;
    }
    return 1;
  };

  const AddonSelectionHandler = (e) => {
    if (e.target.checked === true) {
      const newSelection = selectedAddonData?.filter(
        (val) => val?.id == parseInt(e.target.value)
      );
      SetselectedAddonArray((preVal) => {
        return [...preVal, { addon_item: newSelection }];
      });
    } else {
      SetselectedAddonArray((preVal) => {
        return [
          ...preVal.filter(
            (val) => val?.addon_item?.[0].id !== parseInt(e.target.value)
          ),
        ];
      });
    }
  };

  const fetchZone = async (e) => {
    e.preventDefault();
    setGrowLoading(true);
    if (growingData) {
      setGrowingData("");
    }
    let response = await fetch(`https://phzmapi.org/${zipCode}.json`);
    let zoneResults = false;
    if (response.status == 200) {
      zoneResults = await response.json();
      setGrowingData(zoneResults);
      setGrowLoading(false);
    } else {
      setGrowLoading(false);
      toast.error("zip code not found");
    }
    return zoneResults;
  };

  if (productDetails == null) {
    return (
      <div className="container">
        <div className="row loader-container">
          {[0, 1, 2, 3, 4, 5, 7, 8, 9]?.map((item, index) => {
            return (
              <div className="col-md-12 mt-3" key={index}>
                <Skeleton count={5} />
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <>
      <Header />
      <div className="product-details">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <ProductImagesSlider productDetails={productDetails} />
            </div>
            <div
              className="col-lg-6"
              style={{ zIndex: "9", position: "relative" }}
            >
              <div>
                <div className="row">
                  <div className="col-lg-6">
                    <p className="maples">{productDetails?.category?.name}</p>
                    <h3 className="productName">{productDetails?.name}</h3>
                  </div>
                  <div className="col-lg-6">
                    <div className="tags-right">
                      <p>
                        {" "}
                        Price : $
                        {selectedSize && amount
                          ? amount
                          : selectedSize
                          ? VariationPrice()
                          : productDetails?.variation[0]?.price
                          ? productDetails?.variation[0]?.price
                          : productDetails?.unit_price}
                      </p>
                    </div>
                  </div>
                </div>
                <p className="desc-title">Description</p>
                <p
                  className="productDesc"
                  dangerouslySetInnerHTML={{
                    __html: productDetails?.details,
                  }}
                />
                <p className="desc-title mt-4 mb-4">Additional Information </p>
                <div className="row">
                  <div className="col-lg-6">
                    <p className="productDesc">
                      Latin Name: {productDetails?.latin_name}
                    </p>
                    <p className="productDesc">
                      Common Name: {productDetails?.common_name}
                    </p>
                    <p className="productDesc">
                      Sun Exposure: {productDetails?.sun_exposure}
                    </p>
                    <p className="productDesc">
                      Annual Growth: {productDetails?.annual_growth}
                    </p>
                    <p className="productDesc">
                      HxW @10 Years: {productDetails?.hxw}
                    </p>
                  </div>
                  <div className="col-lg-1 border_product_detail"></div>
                  <div className="col-lg-5">
                    <p className="productDesc">
                      Leaf Type: {productDetails?.leaf_type}
                    </p>
                    {JSON.parse(productDetails?.colors) &&
                    JSON.parse(productDetails?.colors).length > 0 ? (
                      <>
                        {JSON.parse(productDetails?.colors).map(
                          (item, index) => {
                            return (
                              <p className="productDesc" key={index}>
                                Color: {item?.name}
                              </p>
                            );
                          }
                        )}
                      </>
                    ) : null}
                    <p className="productDesc">
                      Growing Zone: {productDetails?.growing_zone?.zone_name}
                    </p>
                    <p className="productDesc">
                      Species: {productDetails?.species}
                    </p>
                    <p className="productDesc">
                      Growth Rate: {productDetails?.growth_rate}
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6  quantity-wrap">
                    {productDetails?.variation?.length > 0 ? (
                      <>
                        <div className="text">Select Size: </div>
                        <div>
                          <>
                            <select
                              name="size"
                              id="size"
                              className="sizeSelect "
                              onChange={(e) => {
                                setSelectedSize(e.target.value);
                                filterVariationQty();
                                setQuantity(1);
                                VariationPrice();
                                SelectedAddonDataHandler(e);
                                setAddonQuantity(1);
                                setSelectedAddOnShow(false);
                              }}
                            >
                              <option selected disabled>
                                Select Size
                              </option>
                              {productDetails?.variation?.map((item, index) => {
                                return (
                                  <option value={item?.size} key={index}>
                                    {item?.size?.replace("_", " ")}
                                  </option>
                                );
                              })}
                            </select>
                          </>
                        </div>
                      </>
                    ) : null}
                  </div>
                  <div className="col-lg-6  quantity-wrap">
                    <div className="text">Select Quantity : </div>
                    <div className="qty-contaner">
                      <button
                        type="button"
                        className="btn qty-btn"
                        onClick={() =>
                          Decrement(productDetails?.productitem?.id)
                        }
                        disabled={quantity <= 1 || amount}
                      >
                        -
                      </button>
                      <p className="qty-num">{quantity}</p>
                      <button
                        type="button"
                        className="btn qty-btn"
                        onClick={() =>
                          Increment(productDetails?.productitem?.id)
                        }
                        disabled={filterVariationQty() == quantity || amount}
                      >
                        +
                      </button>
                    </div>
                  </div>
                  {selectedSize &&
                  filterVariationQty() > 0 &&
                  filterVariationQty() < 10 ? (
                    <p>
                      {" "}
                      {selectedSize?.replace("_", " ")} size: only{" "}
                      {filterVariationQty()}{" "}
                      {filterVariationQty() > 1 ? "items" : "item"} left
                    </p>
                  ) : null}

                  <div className="col-md-12 mt-2">
                    <div>
                      {selectedSize && selectedAddonData?.length > 0 ? (
                        <>
                          <label for="Add">Don't Forget These:</label>
                          <div className="form-group">
                            <div className="row mt-1 mb-2">
                              {selectedAddonData?.map((item) => {
                                return (
                                  <>
                                    <div
                                      className="col-md-3 mt-3"
                                      key={item?.id}
                                    >
                                      <div className="addonContainer">
                                        <div>
                                          <input
                                            type="checkbox"
                                            id={item?.id}
                                            value={item?.id}
                                            onChange={(e) =>
                                              AddonSelectionHandler(e)
                                            }
                                          />
                                        </div>
                                        <div className="addon-img">
                                          <img
                                            src={`${ImageUrlRedux?.product_thumbnail_url}/${item?.thumbnail}`}
                                            className="image-fluid"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-9 addon-data mt-2">
                                      <p>Addon Product: {item?.name}</p>
                                      {item?.variation.length > 0 ? (
                                        <>
                                          <p>
                                            Pack :{" "}
                                            {item?.variation[0]?.size?.replace(
                                              /["_"]/g,
                                              " "
                                            )}
                                          </p>
                                          <p>${item?.variation[0]?.price} </p>
                                        </>
                                      ) : null}
                                    </div>
                                  </>
                                );
                              })}
                            </div>
                          </div>
                        </>
                      ) : null}
                    </div>

                    {selectedAddOnShow &&
                    selectedAddonData &&
                    selectedAddonSizeData ? (
                      <>
                        <div className="row mt-4 mb-2">
                          <div className="col-md-3">
                            <div className="addonContainer">
                              <div className="addon-img">
                                <img
                                  src={`${ImageUrlRedux?.product_thumbnail_url}/${selectedAddonSizeData?.thumbnail}`}
                                  className="image-fluid"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-9 addon-data">
                            <p>Addon Product: {selectedAddonSizeData?.name}</p>
                            {selectedAddonSizeData ? (
                              <>
                                <p>
                                  {selectedAddonSizeData?.variation[0]?.size?.replace(
                                    /["_"]/g,
                                    " "
                                  )}
                                </p>
                                <p>
                                  ${selectedAddonSizeData?.variation[0]?.price}{" "}
                                </p>
                              </>
                            ) : null}
                          </div>
                        </div>

                        <div>
                          {selectedAddOn && selectedAddOnShow ? (
                            <>
                              <p>
                                Addon: only {filterAddonVariationQty()}{" "}
                                {filterAddonVariationQty() > 1
                                  ? "packs"
                                  : "pack"}{" "}
                                left
                              </p>

                              <div className="col-md-6">
                                <div className="form-group">
                                  <label for="Quantity">Addon Quantity </label>
                                  <div className="quantity">
                                    <button
                                      className="minus"
                                      onClick={() => DecrementAddon()}
                                      disabled={addonQuantity <= 1}
                                    >
                                      -
                                    </button>
                                    <span> {addonQuantity}</span>
                                    <button
                                      className={`plus ${filterAddonVariationQty()}`}
                                      onClick={() => IncrementAddon()}
                                      disabled={
                                        filterAddonVariationQty() ==
                                        addonQuantity
                                      }
                                    >
                                      +
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : null}
                        </div>
                      </>
                    ) : null}

                    <div></div>
                  </div>
                </div>
                <div className="col-md-12">
                  {productDetails?.bulk_price &&
                  productDetails?.bulk_price?.length > 0 ? (
                    <div className="variations mt-4">
                      <div className="form-group">
                        <label for="SelectAdds">Choose Your Pack : </label>
                        <div className="input-group">
                          {productDetails?.bulk_price?.map((item, index) => {
                            return (
                              <label
                                className={`${
                                  amount == item?.price
                                    ? "add_container-Selected add_container"
                                    : "add_container"
                                }`}
                                key={index}
                              >
                                <input
                                  type="radio"
                                  hidden
                                  name={`${item?.quantity}${item?.price}`}
                                  value={item?.price}
                                  checked={amount == item?.price ? true : false}
                                  onClick={(e) => SelectPacks(e, item)}
                                />
                                <div className="checkmark">
                                  <h5 className="count"> {item?.quantity}</h5>
                                  <h5 className="price">${item?.price}</h5>
                                </div>
                              </label>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
                <p className="desc-title">Donation </p>
                <div className="row main-borderAmount">
                  <div className="col-lg-6 col-sm-12 col-12 quantity-wrap">
                    <div className="text2">Amount: </div>
                    <div>
                      <select
                        name="size"
                        id="size"
                        className="sizeSelect amountselectdiv"
                        onChange={(e) => setSelectCampPrice(e.target.value)}
                      >
                        <option value="">Amount</option>
                        <option value={"5"}>$5</option>
                        <option value={"12"}>$12</option>
                        <option value={"20"}>$20</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-6 col-sm-12 col-12 quantity-wrap">
                    <div className="text2">Campaign : </div>
                    <div>
                      <select
                        name="size"
                        id="size"
                        className="sizeSelect"
                        onChange={(e) => setSelectCamp_id(e.target.value)}
                      >
                        <option>Select Campaign</option>
                        {CampaignReduxData?.map((item, index) => {
                          return (
                            <>
                              {item?.goal_price != item?.total_donation ? (
                                <option value={item?.id} key={index}>
                                  {item?.title}
                                </option>
                              ) : null}
                            </>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="header-box header-box__growing-zone">
                  <div className="header-box__dropdown">
                    <div className="site-header__box zone-box">
                      <div className="zone-box__content">
                        <form id="setGrowingZone">
                          <input
                            className="form-control"
                            type="text"
                            id="growingZone"
                            name="nursery_growing_zip"
                            placeholder="Enter Zip Code to Find Growing Zone"
                            value={zipCode}
                            onChange={(e) => setZipCode(e.target.value)}
                          />
                          <button
                            type="submit"
                            id="growingZoneBtn"
                            className="btn btn--default btn_product_details_find"
                            onClick={(e) => fetchZone(e)}
                            disabled={growLoading}
                          >
                            {growLoading
                              ? "Loading..."
                              : "Find my Growing Zone"}
                          </button>
                        </form>
                        {growingData ? (
                          <div className="mt-3">
                            <p className="zone-data">
                              Zone : {growingData?.zone}
                            </p>
                            <p className="zone-data">
                              Temperature range :{" "}
                              {growingData?.temperature_range}
                            </p>
                            <p className="zone-data">
                              Lat : {growingData?.coordinates?.lat}
                            </p>
                            <p className="zone-data">
                              Lon : {growingData?.coordinates?.lon}
                            </p>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
                {productDetails?.current_stock > 0 ? (
                  <div className="mt-4 mb-4 cardButtonAdjust ">
                    <button
                      type="button"
                      className="btn sizeBtn"
                      onClick={() => AddToCartHandler(productDetails)}
                    >
                      Add To Cart &nbsp;
                      <span>
                        <ShoppingCartOutlinedIcon
                          style={{ color: "#296253", fontSize: "18px" }}
                          className="cartIcon"
                        />
                      </span>
                    </button>
                    <button
                      type="button"
                      className="btn sizeBtn"
                      onClick={(e) => AddWishListHandler(e)}
                      disabled={wishLoading}
                    >
                      {wishLoading ? "Loading..." : "Add to wishlist"} &nbsp;
                      <span>
                        <FavoriteBorderOutlinedIcon
                          className="heartIcon"
                          style={{ color: "#296253", fontSize: "18px" }}
                        />
                      </span>
                    </button>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          <div className="video-cont">
            <ReactPlayer
              // light={`${ImageUrlRedux?.product_video_thumbnail_url}/${productDetails?.video_thumbnail}`}
              url={`${ImageUrlRedux?.product_video_url}/${productDetails?.video_url}`}
              className="react-player"
              width="100%"
              height="500px"
              overflow="hidden"
              backgroundSize="cover"
              controls
            />
          </div>
          <div className="bottom-container ">
            <section className="ClientsReviewsSec">
              <div className="container">
                <div className="tab-content" id="myTabContent">
                  <div
                    className="tab-pane fade show active"
                    id="reviews"
                    role="tabpanel"
                    aria-labelledby="reviews-tab"
                  >
                    <div className="row bottom_contain">
                      <div className="col-lg-8">
                        <div className="review-container">
                          <div>
                            <AllReviews reviewData={reviewData} />
                          </div>
                          <hr />
                          <div>
                            <ReviewBox
                              handleRating={handleRating}
                              rating={rating}
                              SubmitRating={SubmitRating}
                              comment={comment}
                              setComment={setComment}
                              reviewLoading={reviewLoading}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="map_adjust">
                          <p className="map-title">Hardiness Zone</p>
                          <div className="Map_image">
                            <img
                              src={`${ImageUrlRedux?.growing_zones_url}/${productDetails?.growing_zone?.image}`}
                              alt=""
                              className="image-fluid"
                            />
                          </div>
                        </div>
                        <p className="text-center para_red">
                          Growing Zone :{" "}
                          {productDetails?.growing_zone?.zone_name}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {productDetails?.frequent_products.length > 0 ? (
                  <div className="frequently_bought">
                    <div style={{ zIndex: "9", position: "relative" }}>
                      <div className="row">
                        <h3 className="similar-title">
                          Frequently Brought Together,
                        </h3>

                        {productDetails?.frequent_products?.map(
                          (item, index) => {
                            return (
                              <>
                                {index < 4 ? (
                                  <div
                                    className="col-lg-3 col-md-6"
                                    key={index}
                                  >
                                    <div
                                      className={`${
                                        index == 3
                                          ? "product-box"
                                          : "product-box pro_box"
                                      }`}
                                      id="multi_select"
                                    >
                                      <div
                                        className={`${
                                          addFreq
                                            ?.map((item) => {
                                              return item?.item?.id;
                                            })
                                            .includes(item?.id)
                                            ? "selected-freq pro-img"
                                            : "pro-img"
                                        }`}
                                        onClick={(e) =>
                                          AddFrequentHandler(e, item)
                                        }
                                      >
                                        <figure>
                                          <img
                                            src={
                                              item?.thumbnail
                                                ? `${ImageUrlRedux?.product_thumbnail_url}/${item?.thumbnail}`
                                                : no_image_product_details
                                            }
                                            alt=""
                                            className="img-fluid"
                                          />
                                        </figure>
                                      </div>
                                      <div className="pro-detail">
                                        <div className="name">
                                          <h4>{item?.name}</h4>
                                        </div>
                                        <div className="price">
                                          <h4>
                                            $
                                            {addFreq[index]?.item?.id ==
                                            item?.id
                                              ? addFreq[index]?.selectedPrice
                                              : item?.unit_price}
                                          </h4>
                                        </div>
                                      </div>
                                    </div>
                                    <select
                                      id="size"
                                      className="form-control my-select-drop-icon"
                                      key={index}
                                      onChange={(e) =>
                                        FrequentVariations(e.target.value, item)
                                      }
                                    >
                                      <option selected disabled>
                                        Select Size
                                      </option>
                                      {item?.variation?.map((item2, index) => {
                                        return (
                                          <option
                                            value={item2?.size}
                                            key={index}
                                          >
                                            {item2?.size}
                                          </option>
                                        );
                                      })}
                                    </select>
                                  </div>
                                ) : null}
                              </>
                            );
                          }
                        )}

                        <div className="button-group frequentlybtn">
                          <button
                            className="btn frequentlyBtn mt-3"
                            onClick={(e) => FrequentAddToCartHandler(e)}
                            disabled={waiting || addFreq?.length < 1}
                          >
                            {waiting ? "Please Wait" : "Add to cart"}{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </section>
          </div>
        </div>
      </div>
      <ActionButton />

      <Footer />
    </>
  );
}

export default ProductDetails;
